import React from 'react';

interface Properties {
    embedSrc?: string;
    height?: number;
    width?: number;
    title?: string;
}

export const GenericVideoEmbed = (props: Properties) => {
    const {embedSrc, height, width, title} = props;
    if (!embedSrc) return <div />;

    return (
        <div className="gen-video-embed embed-responsive embed-responsive-16by9">
            <span className="gen-video embed-responsive-item">
                <iframe
                    frameBorder={0}
                    allow="autoplay; fullscreen"
                    allowFullScreen={true}
                    title={title || 'Epic Video Embed'}
                    src={embedSrc}
                    height={height}
                    width={width}
                />
            </span>
        </div>
    );
};
